import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { FaqCategory } from "./FaqCategory";
/**
 * FaqQuestion class
 */

export class FaqQuestion extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return Number(this.model.id);
    };

    this.getCategoryId = () => {
      return Number(this.model.catId);
    };

    this.getQuestion = () => {
      return this.model.question;
    };

    this.getAnswer = () => {
      return this.model.answer;
    };

    this.getVoteTrue = () => {
      return Number(this.model.voteTrue);
    };

    this.getVoteFail = () => {
      return Number(this.model.voteFail);
    };

    this.getShowVoting = () => {
      return Number(this.model.showVoting);
    };

    this.getCreatedAt = () => {
      return this.model.createdAt || 0;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt || 0;
    };

    this.getFaqCategory = category => {
      return this.getRelation('category', FaqCategory, category);
    };
  }

  /**
   * Create list faq questions
   *
   * @param {object} objects
   *
   * @return {Array.<FaqQuestion>}
   */
  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map faq questions
   *
   * @param {Array.<object>} objects
   * @param {function(FaqQuestion): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get faq question id
   *
   * @return {number}
   */


}